import {Subject, Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {CE_ERROR} from './types';
import { generateTimeId } from './collaboration.utils';

export class FirehoseHandle {
  /**
   *
   * @param {Subject} firehose the event bus
   * @param {string} name the document name
   */
  constructor(firehose, name) {
    this.firehose = firehose;
    this.instanceId = generateTimeId();
    this.name = name;
    /**
     * @type {Subscription[]}
     */
    this.knownSubscribers = [];
  }

  /**
   *
   * Make sure when you call this you store the
   * return value and call unsubscribe when you are done!!!
   *
   * @param {string} eventType
   * @param {(*) => *} callback
   * @returns {Subscription}
   */
  on(eventType, callback) {
    const subscriber = this.firehose
      .pipe(
        filter(
          (event) => event.instanceId === this.instanceId && event.type === eventType
        )
      )
      .subscribe((event) => callback(event.data));
    this.knownSubscribers.push(subscriber);
    return subscriber;
  }

  /**
   *
   * @param {string} eventType
   * @param {*} data
   */
  sendEvent(eventType, data) {
    try {
      this.firehose.next({
        type: eventType,
        name: this.name,
        instanceId: this.instanceId,
        data,
      });
    } catch (error) {
      console.error(
        `Error in subscriber for ${eventType} on ${this.name}: ${error?.message}`
      );
    }
  }

  sendError(message) {
    this.sendEvent(CE_ERROR, message);
  }

  close() {
    this.knownSubscribers.map((sub) => sub?.unsubscribe());
  }
}
